var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconBookOpen = function SvgIconBookOpen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31.448,
    height: 24.026,
    viewBox: "0 0 31.448 24.026",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "education",
    transform: "translate(0 -35.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(0 35.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M35.955,35.049h0a1.109,1.109,0,0,0-.788.327,1.121,1.121,0,0,0-.331.8V53.049a1.129,1.129,0,0,0,1.127,1.125c2.619.006,7.008.552,10.036,3.72V40.235a1.078,1.078,0,0,0-.155-.57C43.356,35.663,38.581,35.055,35.955,35.049Z",
    transform: "translate(-31.145 -35.049)",
    fill: "#f6c866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M167.913,53.048V36.173a1.121,1.121,0,0,0-.331-.8,1.109,1.109,0,0,0-.788-.327h0c-2.625.006-7.4.614-9.885,4.616a1.078,1.078,0,0,0-.155.57v17.66c3.028-3.168,7.416-3.714,10.036-3.72A1.129,1.129,0,0,0,167.913,53.048Z",
    transform: "translate(-140.153 -35.048)",
    fill: "#f6c866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M183.647,71.8h-.816V85.91a2.879,2.879,0,0,1-2.87,2.872c-2.222.005-5.885.44-8.48,2.9a27.091,27.091,0,0,1,11.914.23,1.125,1.125,0,0,0,1.377-1.1V72.926A1.126,1.126,0,0,0,183.647,71.8Z",
    transform: "translate(-153.324 -67.909)",
    fill: "#f6c866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M1.941,85.91V71.8H1.125A1.127,1.127,0,0,0,0,72.926V90.81a1.125,1.125,0,0,0,1.377,1.1,27.089,27.089,0,0,1,11.913-.23c-2.594-2.456-6.258-2.89-8.48-2.9A2.879,2.879,0,0,1,1.941,85.91Z",
    transform: "translate(0 -67.909)",
    fill: "#f6c866"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBookOpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-book-open.6d35e16d.svg";
export { ForwardRef as ReactComponent };